import Promise from 'bluebird'
import _find from 'lodash/find'

import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'
import analyticsLib from 'lib/analytics'
import TRACKING_EVENTS from 'constants/trackingEvents'

/**
 * @return {Promise}
 */
export const setCheckoutBooking = function ({ commit }, booking) {
  return commit(mutationTypes.SET_CHECKOUT_BOOKING, booking)
}

/**
 * @return {Promise}
 */
export const setCheckoutCart = function ({ commit }, cart) {
  return commit(mutationTypes.SET_CHECKOUT_CART, cart)
}

/**
 * @return {Promise}
 */
export const setCheckoutOrder = function ({ commit }, order) {
  return commit(mutationTypes.SET_CHECKOUT_ORDER, order)
}

/**
 * @return {Promise}
 */
export const addCartItem = function ({ commit, rootState }, item) {
  if (!item) return Promise.reject(new Error('item is required'))

  const existingItem = _find(rootState.checkout.items, {
    inventoryId: item.inventoryId,
  })

  const existingItemQuantity = existingItem ? existingItem.quantity : 0

  //because we group inventory by group id our store.state.inventory.current
  //doesn't contain inventory objects for all inventory
  //so we need to look in the weights are if it matches too
  const inventory = _find(store.state.inventory.current, (inv) => {
    const matchingWeight = _find(inv.weights, {
      id: item.inventoryId,
    })

    return !!matchingWeight || inv.id === item.inventoryId
  })

  const venue = rootState.venue.current

  const itemQuantityMax = inventory ? inventory.purchaseMax || inventory.quantity || 1 : 1

  const quantity = 1

  const itemItemQuantity = parseInt(existingItemQuantity, 10) + quantity

  if (itemItemQuantity > itemQuantityMax) {
    return store.dispatch('addTopBarNotification', {
      text: 'Sorry, you cannot add more of that item.',
    })
  }

  const trackingData = {
    venueId: venue ? venue.id : null,
    venueName: venue ? venue.name : null,
    inventoryId: inventory ? inventory.id : null,
    inventoryName: inventory ? inventory.name : null,
    inventoryType: inventory ? inventory.type : null,
    inventoryCannabisType: inventory ? inventory.cannabisType : null,
    price: inventory ? inventory.price : null,
    quantity: item.quantity,
  }

  if (existingItem) {
    item.quantity = (parseInt(item.quantity, 10) || 1) + parseInt(existingItem.quantity, 10)

    commit(mutationTypes.REMOVE_CART_ITEM, existingItem.inventoryId)

    trackingData.quantity = item.quantity
  }

  analyticsLib.trackEvent(TRACKING_EVENTS.AddedItemToCart, trackingData)

  return commit(mutationTypes.ADD_CART_ITEM, item)
}

/**
 * @return {Promise}
 */
export const removeCartItem = function ({ commit, rootState }, itemInventoryId) {
  if (!itemInventoryId) return Promise.reject(new Error('itemInventoryId is required'))

  const existingItem = _find(rootState.checkout.items, {
    inventoryId: itemInventoryId,
  })

  const venue = rootState.venue.current

  const trackingData = {
    venueId: venue.id,
    venueName: venue.name,
    inventoryId: existingItem.inventoryId,
    inventoryName: existingItem.inventory.name,
    quantity: existingItem.quantity,
  }

  analyticsLib.trackEvent(TRACKING_EVENTS.RemovedItem, trackingData)

  return commit(mutationTypes.REMOVE_CART_ITEM, existingItem)
}

/**
 * @return {Promise}
 */
export const startCheckout = function ({ commit }) {
  return commit(mutationTypes.START_CHECKOUT)
}

/**
 * @return {Promise}
 */
export const clearCheckoutCartItems = function ({ commit }) {
  return commit(mutationTypes.CLEAR_CHECKOUT_CART_ITEMS)
}

/**
 * @return {Promise}
 */
export const setCheckoutPaymentType = function ({ commit }, paymentType) {
  if (!paymentType) return Promise.reject(new Error('paymentType is required'))

  return commit(mutationTypes.SET_CHECKOUT_PAYMENT_TYPE, paymentType)
}

/**
 * @return {Promise}
 */
export const setCheckoutPaymentProfile = function ({ commit }, paymentProfile) {
  if (!paymentProfile) return Promise.reject(new Error('paymentProfile is required'))

  return commit(mutationTypes.SET_CHECKOUT_PAYMENT_PROFILE, paymentProfile)
}

/**
 * @return {Promise}
 */
export const setCheckoutStripePaymentRequest = function ({ commit }, stripePaymentRequest) {
  if (!stripePaymentRequest) return Promise.reject(new Error('stripePaymentRequest is required'))

  return commit(mutationTypes.SET_CHECKOUT_STRIPE_PAYMENT_REQUEST, stripePaymentRequest)
}

/**
 * @return {Promise}
 */
export const setCheckoutStripePaymentRequestResult = function (
  { commit },
  stripePaymentRequestResult
) {
  return commit(
    mutationTypes.SET_CHECKOUT_STRIPE_PAYMENT_REQUEST_RESULT,
    stripePaymentRequestResult
  )
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout/actions.js